// Module
var code = "<div class=row-fluid> <nlg-script-sql-query-report sql-base-url={{baseUrl}} domain=monitoring filter-service=filterService sql-filter-service-url={{filterServiceUrl}} query=query> </nlg-script-sql-query-report> </div>";
// Exports
module.exports = code;